
  import vdr from '../components/vue-draggable-resizable'
  import qs from 'qs'
  import {mapActions, mapState} from 'vuex'

  export default {
    name: 'preview',
    data() {
      return {
        pmId: this.$route.query.id,
        mainResolutionW: 0,
        mainResolutionH: 0,
        zoom: 1,
        imgsetting: false,
        videosetting: false,
        subtitlesetting: false,
        websetting: false,
        isImgList: false,
        isVideoList: false,
        isText: false,
        isBack: false,
      }
    },
    mounted() {
      this.width = document.getElementById('canvas').offsetWidth
      this.$nextTick(() => {
        document.getElementById('canvas').style.height = `${this.width}px`
      })

      this.$ajax.post('/etv/selectPhoneProgramMould.json', qs.stringify({
        pmId: this.pmId,
      })).then(res => {
        if (res.data.code === 0) {
          document.title = this.$t('append_field.preview')
          const resolution = res.data.data.pmResolution
          this.mainResolutionW = parseInt(resolution.split('*')[0])
          this.mainResolutionH = parseInt(resolution.split('*')[1])
          this.getZoom()
          this.$store.state.componentsList = res.data.data.sceneList[0].componentsList
          this.$store.state.backUrl = this.upFileUrl + res.data.data.sceneList[0].scBackImg
          this.$store.state.sceneList = res.data.data.sceneList[0]
          this.componentsList.map(res => {
            res.infoX = res.coLeftPosition
            res.infoY = res.coRightPosition
            res.infoWidth = res.coWidth
            res.infoHeight = res.coHeight
          })

        }
      })
    },
    methods: {
      ...mapActions(['addControl', 'addSubtitle', 'submit', 'emptyCanvns', 'addBackground']),
      getZoom() {
        if (this.mainResolutionW / this.mainResolutionH > 1) {
          this.zoom = this.mainResolutionW / this.width
          document.getElementById('image').style.height = this.mainResolutionH / this.zoom + 'px'
        } else {
          document.getElementById('image').style.height = '100%'
          this.zoom = this.mainResolutionH / this.width
          document.getElementById('image').style.width = this.mainResolutionW / this.zoom + 'px'
        }
      },
      back() {
        this.$router.back()
      }
    },
    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
        backUrl: state => state.backUrl,
      }),
    },
    components: {
      vdr,
    },
  }
